import React from "react";
import { Link } from "react-router-dom";
import { IconType } from "../../../assets/IconType";
import { ReportLevel } from "./adminReportsApiSlice";

export interface AdminReportBlockConfig {
	heading: string;
	Icon: IconType;
	iconLink?: string;
	links?: {
		text: string;
		link: string;
	}[];
	children?: React.ReactNode;
}

export interface AdminReportBlockProps {
	block: AdminReportBlockConfig;
	reportLevel: ReportLevel;
	className?: string;
}

export function AdminReportBlock(props: AdminReportBlockProps) {
	const config = props.block;
	const { Icon } = config;
	return (
		<div className={`flex w-full md:min-h-32 pb-4 border-b-2 ${props.className}`}>
			<div>
				{config.iconLink ? (
					<Link to={config.iconLink} className="cursor-pointer">
						<Icon className="h-20 text-primary-700" />
					</Link>
				) : (
					<Icon className="h-20 text-primary-700" />
				)}
			</div>
			<div className="pl-4 pt-1">
				<h2>{config.heading}</h2>
				{config.heading === "Performance" && props.reportLevel != ReportLevel.School && (
					<p className="text-sm leading-6 text-gray-600">
						NOTE: There is an additional report available only on the school level.
					</p>
				)}
				{config.links && (
					<ul className="pt-1">
						{config.links.map((link, index) => (
							<li key={index}>
								<Link to={link.link} className="cursor-pointer">
									{link.text}
								</Link>
							</li>
						))}
					</ul>
				)}
				{config.children}
			</div>
		</div>
	);
}
